import { ActivityLog, SearchResultsRecord } from '@agingplan/src';
import { OpensModals } from '@agingplan/src/lib/modal/opens-modals';
import { Directive, Host } from '@angular/core';
import { OperatorFunction, filter, map, switchMap, tap } from 'rxjs';
import { OurDataService } from '../our-data.service';

@Directive()
export class OpensOurDataModals extends OpensModals {
  /**
   * The activity logs to display under the modal
   */
  public activitylogs: ActivityLog[] = [];

  /**
   * Emits when the modal is opened by hooking into the `onVisibilityChanged` event of the modal
   */
  // public visible$ = new BehaviorSubject<boolean>(false);
  public visible$ = this.ourDataService.presentByName$
    .pipe(
      // debugging
      // tap((name) => console.log('Modal', this.name, name)),
      // If the name of the name extending this class is the same as the name of the name passed in then open the modal
      filter((name) => this.name === name),
      // debugging
      // tap((name) => console.log('Modal visibility changed:', this.name, name)),
    )
    .subscribe(() => {
      this.present();
    });

  /**
   * The record we are watching
   */
  public record$ = this.ourDataService.record$.pipe(
    // Switch to the record observable
    switchMap(() => this.ourDataService.record$.pipe(map((record) => record))),
    // filter out undefined
    filter((record) => !!record) as OperatorFunction<SearchResultsRecord | undefined, SearchResultsRecord>,
    // map to a `SearchResultsRecord` object
    map((record) => new SearchResultsRecord(record)),
    // Update the activity logs when the record changes
    tap((record) => (this.activitylogs = record.logs)),
  );

  constructor(@Host() public ourDataService: OurDataService) {
    super();
  }

  /**
   * Opens the ModalComponent ElementRef within the template of the component this directive is attached to
   */
  public async present() {
    if (this.modal) {
      return await this.modal.open().catch(() => this.ourDataService.record$.next(undefined));
    } else {
      throw new Error(`ModalComponent not found on the '${this.constructor.name}' which this directive is attached to.`);
    }
  }
}
